/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IntegrationConfiguration } from '../../models/integration-configuration';

export interface ConfigurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet$Params {
  integrationName: string;
  integrationVersion: string;
}

export function configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet(http: HttpClient, rootUrl: string, params: ConfigurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<IntegrationConfiguration>> {
  const rb = new RequestBuilder(rootUrl, configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet.PATH, 'get');
  if (params) {
    rb.path('integrationName', params.integrationName, {});
    rb.path('integrationVersion', params.integrationVersion, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IntegrationConfiguration>;
    })
  );
}

configurationsIntegrationsIntegrationNameVersionsIntegrationVersionGet.PATH = '/configurations/integrations/{integrationName}/versions/{integrationVersion}';
